/* eslint-disable @typescript-eslint/no-explicit-any */
import get from 'lodash/get';
import substract from 'lodash/subtract';

const stringOps: Record<string, (s: any) => any> = {
  firstLetter: (s) => s.charAt(0),
  toLowerCase: (s) => s.toLowerCase(),
  toUpperCase: (s) => s.toUpperCase(),
  sub: (s) => s.toLowerCase(),
};

/**
 * Replaces `{key}` placeholders with values from `data`.
 * Supports `{a[0].b}` (lodash get), `{key.op}` string operations and `{key.sub(n)}`.
 */
export function replaceValues(text: any, data: any): any {
  if (!text) return text;
  if (!data) return text;

  return text.replace(/{(.*?)}/g, function (_match: string, key: string) {
    if (key.indexOf('[') !== -1) {
      // Use lodash get
      return get(data, key);
    }
    if (key.indexOf('.') !== -1) {
      const [field, op] = key.split('.');
      if (field in data) {
        if (op.includes('sub(')) {
          const number = Number(op[4]); // sub(x)
          if (Number.isNaN(number)) return data[field];
          return substract(data[field], number);
        }
        const f = stringOps[op];
        if (f) return f(data[field]);
        return data[field];
      }
    }

    if (key in data) {
      return data[key];
    }
    return '';
  });
}

/** Resolves a min/max count that may be a template (`"{guestCount}"`) against the data. */
export function computeMinMaxCount(value: any, data: any): any {
  if (typeof value === 'string') {
    const n = Number(replaceValues(value, data));
    if (Number.isNaN(n)) return 0;
    return n;
  }
  return value;
}
